import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface SelectOption {
  valor: string;
  nome: string;
  desabilitado?: boolean;
}

@Component({
  selector: 'app-select-system',
  templateUrl: './select-system.component.html',
  styleUrls: ['./select-system.component.css'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class SelectSystemComponent {
  @Input() placeholder: string = 'Selecione...';
  @Input() opcoes: SelectOption[] = [];
  @Input() valorSelecionado: string | null = null;
  @Input() icone?: string;
  @Output() valorSelecionadoChange = new EventEmitter<string>();

  dropdownAberto = false;
  valorSelecionadoNome: string | null = null;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.drop-sm')) {
      this.dropdownAberto = false;
    }
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.dropdownAberto = !this.dropdownAberto;
  }

  selecionarOpcao(opcao: SelectOption) {
    if (opcao.desabilitado) return;
    
    this.valorSelecionado = opcao.valor;
    this.valorSelecionadoNome = opcao.nome;
    this.dropdownAberto = false;
    this.valorSelecionadoChange.emit(opcao.valor);
  }
}
